const Roles = {
    ADMIN: 'admin',
    BROKER: 'broker',
};

const Status = {
    IN_PROGRESS: "Conversando",
    GENERANTING: "Generando",
    ERROR_HANDOFF: "Error Técnico",
    MANUAL_PAUSE: "Pausa Manual"
}

const CecyIA = "bot";

export {Roles, Status, CecyIA};
